import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudProviderDatabricks = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	id: "b1e71479-2138-44e0-adf0-02fe9fed5c1e",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.155,4.93v.512L9,9.868l7.006-3.957,0,1.6L9,11.491,1.55,7.258l-.395.22V10.54L9,14.955l7.006-3.942,0,1.586L9,16.581,1.55,12.347l-.395.22v.519L9,17.5l7.845-4.414V10.021l-.4-.218L9,14.036,1.992,10.054V8.476L9,12.414,16.845,8V4.978l-.4-.219L9,8.993,2.352,5.215,9,1.46l5.476,3.094.479-.269V3.863L9,.5Z",
		fill: "#ff3621"
	})
});
const ForwardRef = forwardRef(SvgCloudProviderDatabricks);
export { ForwardRef as ReactComponent };
